import { render, staticRenderFns } from "./TargetMemberList.vue?vue&type=template&id=38897bb6&scoped=true&"
import script from "./TargetMemberList.vue?vue&type=script&lang=ts&"
export * from "./TargetMemberList.vue?vue&type=script&lang=ts&"
import style0 from "./TargetMemberList.vue?vue&type=style&index=0&id=38897bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38897bb6",
  null
  
)

export default component.exports